import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api, { fmtMXN } from "@/lib/api";
import { Banknote } from "lucide-react";

export const MyCashPanel = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/cash/my-summary").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s || (s.entregado === 0 && s.gastado === 0)) return null;
  const chips = [
    { label: "EFECTIVO RECIBIDO", value: s.entregado, color: "var(--green)" },
    { label: "GASTADO EN EFECTIVO", value: s.gastado, color: "var(--cyan)" },
    { label: "POR COMPROBAR", value: s.saldo, color: s.saldo > 0 ? "var(--amber, #d97706)" : "var(--green)" },
  ];
  return (
    <div className="panel" data-testid="my-cash-panel">
      <div className="panel-header px-5 py-4 flex items-center justify-between">
        <div>
          <div className="label-mono">// MI CAJA / EFECTIVO</div>
          <h3 className="font-display font-bold text-lg mt-0.5 tracking-wide text-slate-100 flex items-center gap-2"><Banknote className="w-4 h-4" style={{ color: "var(--cyan)" }} /> Efectivo entregado</h3>
        </div>
        <Link to="/cash" data-testid="my-cash-panel-link" className="text-xs font-semibold label-mono hover:underline" style={{ color: "var(--cyan)" }}>VER DETALLE →</Link>
      </div>
      <div className="p-5 grid grid-cols-3 gap-3">
        {chips.map((c) => (
          <div key={c.label}>
            <div className="label-mono text-[9px]" style={{ color: c.color }}>{c.label}</div>
            <div className="font-mono font-bold text-lg mt-1" style={{ color: c.color }}>{fmtMXN(c.value)}</div>
          </div>
        ))}
      </div>
      {s.saldo > 0 && (
        <div className="px-5 pb-4 text-[11px] text-slate-500">Registra tus gastos pagados en <b className="text-slate-300">EFECTIVO</b> en Gastos para comprobar el recurso — se descuentan automáticamente.</div>
      )}
    </div>
  );
};

export default MyCashPanel;
